import { render, staticRenderFns } from "./POIWidgetPreview.vue?vue&type=template&id=42849d6b"
import script from "./POIWidgetPreview.js?vue&type=script&lang=js&external"
export * from "./POIWidgetPreview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports